/*
 * @Author: 黄智强
 * @Date: 2018-02-23 16:04:29
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-11-12 11:56:15
 * @说明：财务管理 接口
 */
// 获取收支明细列表
export const accountLogList = '/account-log/list'
// 短信发送记录日志
export const accountLogUserSmsLog = '/account-log/user-sms-log'
// 获取短信发送状态
export const accountLogSmsStatus = '/account-log/sms-status'
// 获取会员操作日志
export const accountLogGetLog = '/account-log/get-log'
// 获取会员日志类型
export const accountLogGetLogType = '/account-log/get-log-type'
// 当月收入明细
export const accountLogGetStatisticLine = '/account-log/statistic-line'
// 营收概况
export const accountLogGetStatistic = '/account-log/statistic'
// 佣金明细
export const accountLogWithdrawList = '/account-log/withdraw-list'
// 奖励金明细
export const accountLogBonusList = '/account-log/bonus-list'



// WEBPACK FOOTER //
// ./src/api/url/accountLog.js